import { useState, useEffect, type EffectCallback } from 'react';

// Will fire off effect callback once when all values in conditions are truthy
export const useEffectOnConditionOnce = (
  effect: EffectCallback,
  conditions: boolean[],
) => {
  const [called, setCalled] = useState(false);
  const shouldCall = conditions.every(Boolean);

  useEffect(() => {
    if (called) {
      return;
    }

    if (!shouldCall) {
      return;
    }

    setCalled(true);
    return effect();
  }, [called, shouldCall, effect]);

  return [called];
};
